import { ACTION_TYPE } from './action';

const memoDetail = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.CALL_API_UPDATE_MEMO_SUCCESS:
      return {
        ...state,
        resultData: action.data,
        isUpdateSuccess: true,
      };
    case ACTION_TYPE.CALL_API_GET_MEMO_DETAIL_SUCCESS:
      return {
        ...state,
        data: action.data,
      };
    case ACTION_TYPE.RESET_MEMO_DETAIL_FLG:
      return {
        ...state,
        isUpdateSuccess: false,
      };
    default:
      return state;
  }
};

export default memoDetail;
